import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  makeStyles,
  Grid,
  Button,
} from "@material-ui/core";
import { MarkdownEditor } from "@ofqual/portal-components/components/MarkdownEditor";
import React from "react";
import {
  ActionTypeCode,
  InformationRequestAction,
} from "../../../../domain/InformationRequestAction";
import { DownloadLink } from "@ofqual/portal-components/components/DownloadLink";
import {
  actionTypesService,
  informationRequestService,
} from "../../../../services";
import { useSelector } from "react-redux";
import { authSelector } from "../../../../redux/selectors";
import { useLookup } from "@ofqual/portal-core/core/hooks";
import {
  formatUtcDate,
  standardDateFormats,
} from "@ofqual/portal-core/core/utils/dateUtils";

const useStyles = makeStyles((theme) => ({
  actions: {
    padding: 15,
  },
}));

export const ViewActionDialog: React.FC<{
  onClose: () => void;
  action: InformationRequestAction;
}> = ({ onClose, action }) => {
  const classes = useStyles();

  const { token } = useSelector(authSelector);

  const buildGetBlob = (blobId: string) => () =>
    informationRequestService.downloadAttachment(
      action.informationRequestId,
      action.id,
      blobId,
      {
        token,
      }
    );

  const [actionTypesLookups] = useLookup(actionTypesService);
  const actionType = actionTypesLookups.find((x) => x.id === action.actionType);

  const actionTypeName = actionType?.label;
  const actionTypeCode = actionType?.code;

  return (
    <Dialog
      open={true}
      onClose={onClose}
      maxWidth="md"
      fullWidth
      data-test="updated-dialog"
    >
      <DialogTitle data-test="activity-title">
        {actionTypeName}: due{" "}
        {formatUtcDate(action.dueDate, standardDateFormats.DATE)}
      </DialogTitle>
      <Divider />
      <DialogContent>
        <form>
          {(actionTypeCode === ActionTypeCode.SendMessage ||
            actionTypeCode === ActionTypeCode.UploadDocument) && (
            <Grid container spacing={3}>
              <Grid item xs={12}>
                <Grid item xs={12}>
                  <MarkdownEditor value={action.message} readOnly />
                </Grid>
              </Grid>
            </Grid>
          )}

          {actionTypeCode === ActionTypeCode.ReadDocument && (
            <ul style={{ padding: 0, marginLeft: 0, marginTop: 0 }}>
              {action.actionAttachments &&
                action.actionAttachments.map((document) => (
                  <li key={document.blobId} style={{ listStyleType: "none" }}>
                    <DownloadLink
                      fileName={document.fileName}
                      getBlob={buildGetBlob(document.blobId)}
                    />
                  </li>
                ))}
            </ul>
          )}
        </form>
      </DialogContent>
      <DialogActions className={classes.actions}>
        <Button
          onClick={onClose}
          color="primary"
          data-test="close-action-dialog"
        >
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
};
